import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

// import XLSX from 'xlsx';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'
import general from '../../../modulos/general';

import mainNC from '../functions/notas/mainnc';
// "use strict";

//Clientes
const DetArchProc = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.linea}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.descrNodo}</td>
    </tr>
  )
};

const ListaArchProc = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetArchProc elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcAdmClNd extends React.Component {
  state={listaArch: [], checkNoUpd: false, permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  //ACTUALIZAR BD
  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({variables: args});

      //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }
  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){argsCrud[i]._id = codigo}
    }
    for(let i=1; i<totDocCRUD; i++){await this.crudBD(crudColecc[i], argsCrud[i], i)}
    console.log("final")
  }

  handleChange = async (ev) => {
// console.log(ev.target.name)

    const updState = (listaArch) => {
      this.setState({listaArch, errors: []})
    };
    if(ev.target.name==="checkNoUpd"){
      let checkNoUpd = document.getElementById("checkNoUpd").checked
      this.setState({checkNoUpd})
    }
    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        let archcsv = ""
// console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result
          // document.getElementById('out').innerHTML = archcsv;
          // \r
          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()
          //guardar en array lines, cada linea del archivo
          let lines = archivo.split(/\n/)
          let numArch = 0, linea = 0, listaArch = []
          lines.forEach(line => {
            if(line&&(numArch>0||(numArch===0&&!checkTieneEncab))){
              let tieneEnter = line.substring(line.length - 1, line.length);
              let lineCorregida = line
              if(tieneEnter==="\r"){
                lineCorregida = line.substring(0, line.length - 1);
              }
              linea += 1
              //crear array de campos para cada linea
              let campos = lineCorregida.split(";")
              let contrato = campos[0]
              let descrNodo = campos[1]
              listaArch.push({linea, contrato, descrNodo})
            }
            numArch += 1
          })
          updState(listaArch)
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
      }else{
        this.setState({listaArch: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listaArch)=>{
    let errors = []
    if(listaArch.length===0){
      errors.push({path: "Clientes", message: "No hay clientes"});
    }
    // console.log(listaArch.length)
    document.body.style.cursor = 'wait'
    let nodos = await this.props.allNodo.allNodo
    let actCli = [], actCliMany = [], actCliMany1 = []
    let argsUpd = {}
    for(let ii=0; ii<listaArch.length; ii++){
      // console.log(listaArch[ii])
      let elemento = listaArch[ii]
      // console.log(ii, elemento.contrato)
      // if(!elemento.contrato||!elemento.descrNodo){
      if(!elemento.contrato){
        errors.push({path: "Clientes", message: `Datos inválidos en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}, Nodo: ${elemento.descrNodo}`});
      }
      if(this.props.allNodo.allNodo){
        let nodoArch = listaArch[ii].descrNodo.trim()
        let indexNodo = nodos.findIndex(elementoNd => elementoNd.descrNodo===nodoArch)
        // if(indexNodo===-1){
        if(indexNodo===-1&&nodoArch!==""){
          errors.push({path: "Nodo", message: `Nodo NO existe en línea No. ${elemento.linea} => Nodo: ${elemento.descrNodo}`});
        }else{
          // if(this.props.allClientes.allClientes){
          //   let {data} = await this.props.allClientes.refetch({contrato: listaArch[ii].contrato, numDocum: 1327})
          //   let allClientes = await data.allClientes
          //   if(allClientes.length===0){
          //     errors.push({path: "Clientes", message: `Contrato NO existe en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
          //   }else{
              // if(!this.state.checkNoUpd||(this.state.checkNoUpd&&!allClientes[0].descrNodo)){
                argsUpd = {
                  "tipoAct": "EditarNodo",
                  "contrato": listaArch[ii].contrato,
                  "descrNodo": nodoArch,
                }
                actCli.push(argsUpd)

                // actCli.forEach((elemento, ii) => {
                //   actCliMany.push(elemento)
                // })
                // actCliMany1.push({cliente: actCliMany})
        
                // let numDocCRUD = 0, totDocCRUD = 1
                // let argsCrud = [], crudColecc = []
                // for(let iii=0; iii<totDocCRUD; iii++){
                //   argsCrud.push({ctrlCampo: 'NO_CRUD'})
                // }
                // for(let iii=0; iii<totDocCRUD; iii++){
                //   crudColecc.push(this.props.editClienteMany)
                // }
        
                // argsCrud[numDocCRUD] = actCliMany1[0]
                // argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
                // argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
                // crudColecc[numDocCRUD] = this.props.editClienteMany
        
                // this.updColecc(crudColecc, argsCrud, totDocCRUD)




                // let editMarquilla = []
                // let clienteSel = allClientes[0]

                // console.log(this.state.checkNoUpd, clienteSel.contrato, clienteSel.descrNodo)

                // const _idCli = clienteSel._id
                // let argsUpd = {
                //   "accionBD": this.props.editCliente,
                //   "tipoAct": "EditarMarquillaNodo",
                //   "_id": _idCli,
                //   "codigoMarquilla": clienteSel.codigoMarquilla?clienteSel.codigoMarquilla:"",
                //   "descrNodo": listaArch[ii].descrNodo,
                //   "codigoPaquete": clienteSel.codigoPaquete?clienteSel.codigoPaquete:"",
                //   "descrPaquete": clienteSel.descrPaquete?clienteSel.descrPaquete:"",
                //   "noFactOSAb": false,
                // }
                // editMarquilla.push(argsUpd)
                // await this.props.editCliente({
                //   variables: editMarquilla[0]
                // });
                // console.log(clienteSel.contrato)
              // }
            // }
          // }
        }
      }
    }
    // console.log(actCli.length)
    actCli.forEach((elemento, ii) => {
      actCliMany.push(elemento)
    })
    actCliMany1.push({cliente: actCliMany})

    let numDocCRUD = 0, totDocCRUD = 1
    let argsCrud = [], crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editClienteMany)
    }

    argsCrud[numDocCRUD] = actCliMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editClienteMany

    await this.updColecc(crudColecc, argsCrud, totDocCRUD)


    document.body.style.cursor = 'default'
    // console.log(errors.length)
    this.setState({errors})
    this.setState({listaArch: []})
    // if(errors.length===0){
    //   // PROCESO ACTUALIZAR CLIENTES CON EL NODO
    //   document.body.style.cursor = 'wait'

    //   let iii = 0, contratoFinProc = listaArch[listaArch.length-1].contrato, contratoFin = ""

    //   const startTime = async (listaArch, allCli, editCliente) => {
    //     let clienteSel = {}

    //     setTimeout(async ()=>{
    //       if(iii<listaArch.length){
    //         if(allCli){
    //           let {data} = await allCli.refetch({contrato: listaArch[iii].contrato, numDocum: 1327})
    //           let allClientes = await data.allClientes
    //           clienteSel = allClientes[0]
    //         }
    //         let editMarquilla = []
    //         const _idCli = clienteSel._id
    //         let argsUpd = {
    //           "accionBD": this.props.editCliente,
    //           "tipoAct": "EditarMarquillaNodo",
    //           "_id": _idCli,
    //           "codigoMarquilla": clienteSel.codigoMarquilla?clienteSel.codigoMarquilla:"",
    //           "descrNodo": listaArch[iii].descrNodo,
    //           "codigoPaquete": clienteSel.codigoPaquete?clienteSel.codigoPaquete:"",
    //           "descrPaquete": clienteSel.descrPaquete?clienteSel.descrPaquete:"",
    //           "noFactOSAb": false,
    //         }
    //         editMarquilla.push(argsUpd)
    //         await this.props.editCliente({
    //           variables: editMarquilla[0]
    //         });

    //         contratoFin = listaArch[iii].contrato

    //         await startTime(listaArch, allCli, editCliente)
    //         // console.log(iii, "contrato ", contratoFin, contratoFinProc)
    //         if(contratoFin===contratoFinProc || iii === listaArch.length - 1){
    //           setTimeout(async () => {
    //             this.setState({listaArch: []})
    //             document.body.style.cursor = 'default'
    //           }, 600)

    //           // console.log("timeout fin", iii)
    //         }

    //         iii += 1
    //       } 
    //     }, 200);
    //   }
    //   await startTime(listaArch, this.props.allClientes, this.props.editCliente)

    // }
    
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  // async componentDidUpdate(prevProps){

  // }

  render(){
    const {listaArch, checkNoUpd, permiteUpdate, confirmaAct, open,
            errors} = this.state;

    let mensaje = "ACTUALIZAR CLIENTES CON EL NODO"
    let imgIcon = "images/archivo_32.png"

    // console.log(checkNoUpd)

    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input
// console.log(listaArch)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Procesar archivo
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listaArch):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <h1 style={{color: '#2C7744'}}>Procesar archivo para actualizar clientes con el nodo</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <hr></hr>
                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                      {/* <output id="out" style={estilos1}>
                          file contents will appear here
                      </output> */}
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                      {/* <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkNoUpd"
                                  checked={checkNoUpd} name="checkNoUpd" onChange={this.handleChange}/>
                          &nbsp;&nbsp;NO actualizar los clientes que ya tengan nodo asignado
                        </p>
                      </Form.Field> */}
                    </div>

                  </div>
                </div>
                <br/>
                <hr></hr>
                <hr></hr>

                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total clientes:  {listaArch.length}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                  errors.length?<Message negative header="No se asociaron los siguientes Nodos:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

                <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                    <th className=''>No.</th>  
                    <th className=''>Contrato</th>
                    <th className=''>Nodo</th>
                    </tr>
                  </thead>
                  <ListaArchProc list={listaArch}/>
                </table>
              </div>

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.query.allNodo, {name:'allNodo'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),

  // graphql(queries.mutation.editCliente, {name:'editCliente'}),
)(ProcAdmClNd)
